import { type ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const LegacyWorkspaceSettingsRedirect = (): ReactElement => {
  const location = useLocation();
  const nextSearchParams = new URLSearchParams(location.search);
  const legacyOrganisationId = nextSearchParams.get('organisationId');
  if (legacyOrganisationId !== null && !nextSearchParams.has('workspaceId')) {
    nextSearchParams.set('workspaceId', legacyOrganisationId);
    nextSearchParams.delete('organisationId');
  }
  const nextSearch = nextSearchParams.toString();
  const nextUrl = `/workspace-settings${nextSearch.length > 0 ? `?${nextSearch}` : ''}${location.hash}`;
  return <Navigate to={nextUrl} replace />;
};
